import{useSelector as t}from"react-redux";import{REDUCER_SUPPORT_MODAL_NAME as r}from"../constants/index.js";const e=()=>t(o=>o[r]);export{e as useSupportModalState};
